module.exports = __webpack_public_path__ + "static/media/save_floppy_green.ee00d86e.svg";